import React from 'react';
import navbar from '../../assets/field/assimilation-navbar.svg';
import navbarCompact from '../../assets/field/assimilation-navbar-compact.svg';
import './AssimilationVeins.css';

export default function AssimilationVeins({ className = '' }) {
  const artwork = <img className={`assimilation-veins assimilation-veins--navbar ${className}`} src={navbar} alt="" aria-hidden="true" decoding="async" draggable="false" />;
  return <picture><source media="(max-width: 1024px)" srcSet={navbarCompact} />{artwork}</picture>;
}
